import { Instructor } from 'common/src/api/core/courses/types'
import React, { ReactElement, useMemo } from 'react'
import Modal from 'antd/lib/modal/Modal'
import styles from './InstructorModal.module.scss'
import { INSTRUCTOR_TO_INSTRUCTOR_DATA } from '@/components/Courses/InstructorModal/instructorData'
import { reusableCssClass } from '@/utils/reusableCssClasses'

interface InstructorModalProps {
    instructor: Instructor | null
    setActiveInstructor: (instructor: Instructor | null) => void
}
export const InstructorModal: React.FC<InstructorModalProps> = (
    props
): ReactElement => {
    const modalContents = useMemo((): ReactElement => {
        if (!props.instructor) {
            return
        }

        return (
            <div className={styles.instructorModalContainer}>
                <div className={styles.informationContainer}>
                    <div className={styles.informationHeader}>
                        <div className={styles.informationHeaderDiv}>
                            {
                                INSTRUCTOR_TO_INSTRUCTOR_DATA[props.instructor]
                                    .imageComponent
                            }
                        </div>
                        <div className={styles.informationHeaderDiv}>
                            <div className={styles.title}>
                                Meet your Instructor
                            </div>
                            <div className={styles.instructorName}>
                                {
                                    INSTRUCTOR_TO_INSTRUCTOR_DATA[
                                        props.instructor
                                    ].prettyName
                                }
                            </div>
                        </div>
                    </div>
                    <div className={styles.description}>
                        {
                            INSTRUCTOR_TO_INSTRUCTOR_DATA[props.instructor]
                                .textContent
                        }
                    </div>
                </div>
            </div>
        )
    }, [props.instructor])

    return (
        <Modal
            key={props.instructor}
            open={!!props.instructor}
            onCancel={() => props.setActiveInstructor(null)}
            footer={null}
            className={styles.instructorModal}
        >
            {modalContents}
        </Modal>
    )
}
